<template>
  <b-container class="p-main-container">
    <b-row>
      <b-col>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="viewSanction"
          variant="warning"
          v-if="ApplicationStatus==16 || ApplicationStatus==8 || ApplicationStatus==9 || ApplicationStatus==11"
        >Sanction Letter</b-button>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="printLoi"
          variant="success"
          v-if="ApplicationStatus==6 || ApplicationStatus==16 || ApplicationStatus==8 || ApplicationStatus==9 || ApplicationStatus==10 || ApplicationStatus==11 || isLoiExtensionStatus(ApplicationStatus)"
        >LOI</b-button>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="printLoiOld"
          variant="success"
          v-if="ApplicationStatus==27"
        >PREVIOUS LOI</b-button>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="extendLoi"
          variant="warning"
          v-if="(ApplicationStatus==6 || ApplicationStatus==8 || ApplicationStatus==9 || ApplicationStatus==10 || ApplicationStatus==11 || isLoiExtensionStatus(ApplicationStatus)) && (RoleID==3 || RoleID==4 || RoleID==5 || RoleID==6 || RoleID==10)"
        >Extend LOI</b-button>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          variant="info"
          @click="print"
        >Print Profile</b-button>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          @click.prevent="goback"
          variant="secondary"
          size="sm"
        >BACK</b-button>
      </b-col>
    </b-row>
    <div id="printme">
      <div>
        <b-row>
          <b-col cols="8" offset="1">
            <b-container class="bv-example-row">
              <table>
                <tr>
                  <td>
                    <span class="app-bold">Application No:</span>
                    <span class="mr-5">{{personalDetails.LoanApplicationNo}}</span>
                  </td>
                  <td>
                    <span class="app-bold ml-5">Application Date:</span>
                    <span>{{personalDetails.ApplicationDate}}</span>
                  </td>
                </tr>
              </table>
            </b-container>
          </b-col>
        </b-row>
      </div>
      <div class="application-view">
        <div></div>
        <div class="reg-form-box">
          <div class="reg-form-body">
            <b-container class="bv-example-row">
              <b-row>
                <b-col cols="8" offset="1">
                  <b-container class="bv-example-row">
                    <h5 class="reg-form-title text-primary">Personal Details</h5>

                    <!-- <b-row>
                      <b-col>Application No: {{personalDetails.LoanApplicationNo}}</b-col>
                    </b-row>-->

                    <table class="profile-table table-3x">
                      <tbody>
                        <tr>
                          <td>
                            <span class="bold">First Name:</span>
                            {{personalDetails.FirstName}}
                          </td>
                          <td>
                            <span class="bold">Middle Name:</span>
                            {{personalDetails.MiddleName}}
                          </td>
                          <td>
                            <span class="bold">Last Name:</span>
                            {{personalDetails.LastName}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Date Of Birth:</span>
                            {{personalDetails.DOB}}
                          </td>
                          <td>
                            <span class="bold">Aadhar Id:</span>
                            {{personalDetails.AdharNo}}
                          </td>
                          <td>
                            <span class="bold">Mobile No.:</span>
                            {{personalDetails.Mobile}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Email:</span>
                            {{personalDetails.EmailID}}
                          </td>
                          <td>
                            <span class="bold">Gender:</span>
                            <span v-if="personalDetails.Gender">Male</span>
                            <span v-else>Female</span>
                          </td>
                          <td>
                            <span class="bold">Pan Card No.:</span>
                            {{personalDetails.PanCardNo}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Maharashtra Domicile:</span>
                            <span v-if="personalDetails.Domiciled">Yes</span>
                            <span v-else>No</span>
                          </td>
                          <td>
                            <span class="bold">Ration Card No:</span>
                            {{personalDetails.RationCardNo}}
                          </td>
                          <td>
                            <span class="bold">Total Income:</span>
                            {{personalDetails.FamilyIncome}}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Caste:</span>
                            {{personalDetails.CasteName}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-container>
                </b-col>

                <!-- <b-col cols="2" offset>
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto"
                          :src="getImgUrl(personalDetails.PhotoPath)"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto;display:none"
                          :src="getImgUrl(personalDetails.SignaturePath)"
                        />
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>-->
              </b-row>
            </b-container>
          </div>
        </div>
      </div>

      <!-- *********** -->

      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Address Details</h5>

                  <table class="profile-table table-3x">
                    <tbody>
                      <tr>
                        <td colspan="3">
                          <span class="bold">Address:</span>
                          {{personalDetails.Address}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Taluka:</span>
                          {{personalDetails.TalukaName}}
                        </td>
                        <td>
                          <span class="bold">District:</span>
                          {{personalDetails.DistrictName}}
                        </td>
                        <td>
                          <span class="bold">State:</span>
                          {{personalDetails.StateName}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- ********* -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Account</h5>
                  <table class="profile-table table-3x">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Bank Account No:</span>
                          {{personalDetails.BankAccountNo}}
                        </td>

                        <td>
                          <span class="bold">Bank IFSC Code:</span>
                          {{personalDetails.BankIfscCode}}
                        </td>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{personalDetails.BankName}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Branch Name:</span>
                          {{personalDetails.BranchName}}
                        </td>
                        <td>
                          <span class="bold">City:</span>
                          {{personalDetails.BankCity}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- Group details -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <!-- <b-container class="bv-example-row">
            <b-row>
              <b-col cols="3"></b-col>
              <b-col cols="9" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Family Details</h5>
                  <table class="profile-table info-table">
                    <tr>
                      <th>Full Name</th>
                      <th>Gender</th>
                      <th>Date of Birth</th>
                      <th>Relation Ship</th>
                    </tr>
                    <tr v-for="member in familyDetails" :key="member.FamilyDetailID">
                      <td>{{member.FullName}}</td>
                      <td v-if="member.Gender">Male</td>
                      <td v-else>Female</td>
                      <td>{{member.DOB}}</td>
                      <td>{{member.RelationshipName}}</td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container> -->
        </div>
      </div>
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="10" offset="1">
                <b-container class="bv-example-row group-details-container">
                  <h5 class="reg-form-title text-primary">Group Details</h5>
                  <table class="profile-table table-3x">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <span class="bold">Group Name:</span>
                          {{personalDetails.GroupName}}
                        </td>
                        <td>
                          <span class="bold">Registration No:</span>
                          {{personalDetails.CompanyRegNo}}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <span class="bold">Registerd Address:</span>
                          {{personalDetails.GroupRegisteredAddress}}
                        </td>
                        <td>
                          <span class="bold">Under Disability?</span>
                          <span v-if="personalDetails.IsUnderDisability">Yes</span>
                          <span v-else>No</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Group PAN:</span>
                          {{personalDetails.GroupPAN}}
                        </td>
                        <td>
                          <span class="bold">Group TAN:</span>
                          {{personalDetails.GroupTAN}}
                        </td>
                        <td>
                          <span class="bold">Company/Group Type:</span>
                          {{personalDetails.EmployerCompanyType}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- Group details ends -->
      <!--Lending Bank Details-->
      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Lending Loan Details</h5>

                  <table class="profile-table" style="margin-left:0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Loan District:</span>
                          {{personalDetails.LoanDistrict}}
                        </td>
                        <td colspan="2">
                          <span class="bold">Business Name:</span>
                          {{personalDetails.BusinessName}}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <span class="bold">Business Address:</span>
                          {{personalDetails.BusinessAddress}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Taluka:</span>
                          {{personalDetails.BusinesTalukaName}}
                        </td>
                        <td>
                          <span class="bold">District:</span>
                          {{personalDetails.BusinessDistrict}}
                        </td>
                        <td>
                          <span class="bold">Product:</span>
                          {{personalDetails.FinalProduct}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Amount From Bank:</span>
                          {{personalDetails.LoanAmount}}
                        </td>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{personalDetails.LoanBank}}
                        </td>
                        <td>
                          <span class="bold">Branch:</span>
                          {{personalDetails.LoanBranch}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!--Lending Bank Ends-->

      <!-- directors starts -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="10" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Directors</h5>
                  <table
                    class="profile-table table-3x mt-4"
                    v-for="member in directorDetails"
                    :key="member.GroupDirectorID"
                  >
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">First Name:</span>
                          {{member.DirectorFirstName}}
                        </td>
                        <td>
                          <span class="bold">Middle Name:</span>
                          {{member.DirectorMiddleName}}
                        </td>
                        <td>
                          <span class="bold">Last Name:</span>
                          {{member.DirectorLastName}}
                        </td>
                        <td rowspan="5">
                          <img style="width:100px;height:auto;" :src="getImgUrl(member.PhotoPath)" />
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <span class="bold">Address:</span>
                          {{member.DirectorAddress}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Date Of Birth:</span>
                          {{member.DirectorDOB}}
                        </td>
                        <td>
                          <span class="bold">Mobile No.:</span>
                          {{member.DirectorMobile}}
                        </td>
                        <td>
                          <span class="bold">Email:</span>
                          {{member.DirectorEmail}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Designation:</span>
                          {{member.DirectorDesignation}}
                        </td>
                        <td>
                          <span class="bold">Aadhar Id:</span>
                          {{member.DirectorAadhar}}
                        </td>
                        <!-- <td>
                          <span class="bold">Gender:</span>
                          <span v-if="member.Gender">Male</span>
                          <span v-else>Female</span>
                        </td>-->
                        <td>
                          <span class="bold">Pan Card No.:</span>
                          {{member.DirectorPAN}}
                        </td>
                      </tr>
                      <!-- <tr>

                        <td>
                          <span class="bold">Ration Card No:</span>
                          {{personalDetails.RationCardNo}}
                        </td>
                        <td>
                          <span class="bold">Total Income:</span>
                          {{personalDetails.FamilyIncome}}
                        </td>
                      </tr>-->
                      <tr>
                        <td colspan="3">
                          <span class="bold">Caste:</span>
                          {{member.DirectorCaste}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <table class="profile-table info-table">
                    <tr>
                      <th>First Name</th>
                      <th>Middel Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Designation</th>
                      <th>Aadhar No.</th>
                      <th>Address</th>
                      <th>Mobile No.</th>
                    </tr>
                    <tr v-for="member in personalDetails.GroupDirectors" :key="member">
                      <td>{{member.DirectorFirstName}}</td>
                      <td>{{member.DirectorMiddleName}}</td>
                      <td>{{member.DirectorLastName}}</td>
                      <td>{{member.DirectorEmail}}</td>
                      <td>{{member.DirectorDesignation}}</td>
                      <td>{{member.DirectorAadhar}}</td>
                      <td>{{member.DirectorAddress}}</td>
                      <td>{{member.DirectorMobile}}</td>
                    </tr>
                  </table>-->
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- directors ends -->

      <!-- shareholders details start -->
      <!-- <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="10" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Shareholders Details</h5>
                  <table class="profile-table info-table">
                    <tr>
                      <th>First Name</th>
                      <th>Middle Name</th>
                      <th>Last Name</th>
                      <th>Gender</th>
                      <th>Address</th>
                      <th>DOB</th>
                      <th>Aadhar</th>
                    </tr>
                    <tr v-for="member in shareholderDetails" :key="member">
                      <td>{{member.ShareholderFirstName}}</td>
                      <td>{{member.ShareholderMiddleName}}</td>
                      <td>{{member.ShareHolderLastName}}</td>
                      <td v-if="member.ShareholderGender=='1'">Male</td>
                      <td v-else>Female</td>
                      <td>{{member.ShareholderAddress}}</td>
                      <td>{{member.ShareholderDOB}}</td>
                      <td>{{member.ShareHolderAadhar}}</td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div> -->
      <!-- shareholder details ends -->
      <!-- documents -->

      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Group Documents Uploaded</h5>
                  <table class="profile-table doc-table">
                    <tr>
                      <th>Sr No</th>
                      <th>Document Type</th>
                      <th>Value</th>
                      <th>Link</th>
                    </tr>
                    <tr v-if="personalDetails.PhotoPath !=''">
                      <td>00.</td>
                      <td>Photo</td>
                      <td></td>
                      <td>
                        <a target="_blank" :href="getImgUrl(personalDetails.PhotoPath)">View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.RegCopy  !=''">
                      <td>01.</td>
                      <td>Company/Group Registration Certificate</td>
                      <td></td>
                      <td>
                        <span v-if="personalDetails.RegCopy ==''">Not Uploaded</span>
                        <span v-if="personalDetails.RegCopy !=''">
                          <a target="_blank" :href="getImgUrl(personalDetails.RegCopy)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr v-if="personalDetails.PersonResolutionPath !=''">
                      <td>02.</td>
                      <td>Authorization Resolution</td>
                      <td></td>
                      <td>
                        <span v-if="personalDetails.PersonResolutionPath ==''">Not Uploaded</span>
                        <span v-if="personalDetails.PersonResolutionPath !=''">
                          <a
                            target="_blank"
                            :href="getImgUrl(personalDetails.PersonResolutionPath)"
                          >View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>03.</td>
                      <td>Adhar Card</td>
                      <td>{{personalDetails.AdharNo}}</td>
                      <td>
                        <span v-if="personalDetails.AddharCardPath ==''">Not Uploaded</span>
                        <span v-if="personalDetails.AddharCardPath !=''">
                          <a target="_blank" :href="getImgUrl(personalDetails.AddharCardPath)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>04.</td>
                      <td>Adhar Card BackSide</td>
                      <td></td>
                      <td>
                        <span v-if="personalDetails.AddharCardBackPath ==''">Not Uploaded</span>
                        <span v-if="personalDetails.AddharCardBackPath !=''">
                          <a
                            target="_blank"
                            :href="getImgUrl(personalDetails.AddharCardBackPath)"
                          >View</a>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>05.</td>
                      <td>Bank Account</td>
                      <td></td>
                      <td>
                        <span v-if="personalDetails.BankAccount ==''">Not Uploaded</span>
                        <span v-if="personalDetails.BankAccount !=''">
                          <a target="_blank" :href="getImgUrl(personalDetails.BankAccount)">View</a>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="(personalDetails.OtherDocument !='' && personalDetails.OtherDocument != null) || (personalDetails.Other1 !='' && personalDetails.Other1 != null)">
                      <td>06.</td>
                      <td>{{personalDetails.OtherName || personalDetails.Other1Name}}</td>
                      <td></td>
                      <td>
                        <a target="_blank" :href="getImgUrl(personalDetails.OtherDocument || personalDetails.Other1)">View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.Other2 !='' && personalDetails.Other2 != null">
                      <td>07.</td>
                      <td>{{personalDetails.Other2Name}}</td>
                      <td></td>
                      <td>
                        <a target="_blank" :href="getImgUrl(personalDetails.Other2)">View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.Other3 !='' && personalDetails.Other3 != null">
                      <td>08.</td>
                      <td>{{personalDetails.Other3Name}}</td>
                      <td></td>
                      <td>
                        <a target="_blank" :href="getImgUrl(personalDetails.Other3)">View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.Other4 !='' && personalDetails.Other4 != null">
                      <td>09.</td>
                      <td>{{personalDetails.Other4Name}}</td>
                      <td></td>
                      <td>
                        <a target="_blank" :href="getImgUrl(personalDetails.Other4)">View</a>
                      </td>
                    </tr>
                  </table>
                </b-container>
                <b-container
                  class="bv-example-row mt-3"
                  v-for="(director, index) in directorDetails"
                  :key="index"
                >
                  <h5 class="reg-form-title text-primary">Director-{{index+1}} Documents Uploaded</h5>
                  <table class="profile-table doc-table" style="margin-left:0">
                    <tr>
                      <th>Sr No</th>
                      <th>Document Type</th>
                      <th>Value</th>
                      <th>Link</th>
                    </tr>
                    <tr>
                      <td>01.</td>
                      <td>Photo</td>
                      <td></td>
                      <td>
                        <span v-if="director.PhotoPath ==''">Not Uploaded</span>
                        <span v-if="director.PhotoPath !=''">
                          <a target="_blank" :href="getImgUrl(director.PhotoPath)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>02.</td>
                      <td>PAN Card</td>
                      <td>{{director.DirectorPAN}}</td>
                      <td>
                        <span v-if="director.PancardPath ==''">Not Uploaded</span>
                        <span v-if="director.PancardPath !=''">
                          <a target="_blank" :href="getImgUrl(director.PancardPath)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>03.</td>
                      <td>Adhar Card</td>
                      <td>{{director.DirectorAadhar}}</td>
                      <td>
                        <span v-if="director.AddharCardPath ==''">Not Uploaded</span>
                        <span v-if="director.AddharCardPath !=''">
                          <a target="_blank" :href="getImgUrl(director.AddharCardPath)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>03.</td>
                      <td>Adhar Card BackSide</td>
                      <td></td>
                      <td>
                        <span v-if="director.AddharCardBackPath ==''">Not Uploaded</span>
                        <span v-if="director.AddharCardBackPath !=''">
                          <a target="_blank" :href="getImgUrl(director.AddharCardBackPath)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>05.</td>
                      <td>CIBIL Score Proof</td>
                      <td>{{director.DirectorCibil}}</td>
                      <td>
                        <span v-if="director.CibilProof ==''">Not Uploaded</span>
                        <span v-if="director.CibilProof !=''">
                          <a target="_blank" :href="getImgUrl(director.CibilProof)">View</a>
                        </span>
                      </td>
                    </tr>

                    <!-- <tr>
                    <td>06.</td>
                    <td>Ration Card Last Page</td>
                    <td>{{personalDetails.RationCardNo}}</td>
                    <td>
                      <span v-if="director.RationCardLastPath ==''">Not Uploaded</span>
                      <span v-if="director.RationCardLastPath !=''">
                        <a target="_blank" :href="getImgUrl(director.RationCardLastPath)">View</a>
                      </span>
                    </td>
                    </tr>-->

                    <tr>
                      <td>06.</td>
                      <td>Caste Certificate</td>
                      <td>{{director.DirectorCaste}}</td>
                      <td>
                        <span v-if="director.CasteCertificate ==''">Not Uploaded</span>
                        <span v-if="director.CasteCertificate !=''">
                          <a target="_blank" :href="getImgUrl(director.CasteCertificate)">View</a>
                        </span>

                        </td>

                    </tr>

                    <tr>
                      <td>07.</td>
                      <td>Birth Certificate</td>
                      <td>{{director.DirectorDOB}}</td>
                      <td>
                        <span v-if="director.BirthCertificate ==''">Not Uploaded</span>
                        <span v-if="director.BirthCertificate !=''">
                          <a target="_blank" :href="getImgUrl(director.BirthCertificate)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>08.</td>
                      <td>Residance Address</td>
                      <td></td>
                      <td>
                        <span v-if="director.ResidentialProofPath ==''">Not Uploaded</span>
                        <span v-if="director.ResidentialProofPath !=''">
                          <a target="_blank" :href="getImgUrl(director.ResidentialProofPath)">View</a>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>09.</td>
                      <td>Domicile Certificate</td>
                      <td></td>
                      <td>
                        <span v-if="director.DomicileCertificate ==''">Not Uploaded</span>
                        <span v-if="director.DomicileCertificate !=''">
                          <a target="_blank" :href="getImgUrl(director.DomicileCertificate)">View</a>
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>10.</td>
                      <td>Income Certificate</td>
                      <td></td>
                      <td>
                        <span v-if="director.IncomeCertificatePath ==''">Not Uploaded</span>
                        <span v-if="director.IncomeCertificatePath !=''">
                          <a target="_blank" :href="getImgUrl(director.IncomeCertificatePath)">View</a>
                        </span>
                      </td>
                    </tr>
                    <!-- <tr>
                      <td>11.</td>
                      <td>Bank Account Proof</td>
                      <td>{{personalDetails.BankAccountNo}}</td>
                      <td>
                        <span v-if="director.BankAccount ==''">Not Uploaded</span>
                        <span v-if="director.BankAccount !=''">
                          <a target="_blank" :href="getImgUrl(director.BankAccount)">View</a>
                        </span>
                      </td>
                    </tr> -->
                    <tr v-if="director.Other1 !=''">
                      <td>11.</td>
                      <td>{{director.Other1Name}}</td>
                      <td></td>
                      <td>
                        <span v-if="director.Other1 ==''">Not Uploaded</span>
                        <span v-if="director.Other1 !=''">
                          <a target="_blank" :href="getImgUrl(director.Other1)">View</a>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="director.Other2 !=''">
                      <td>13.</td>
                      <td>{{director.Other2Name}}</td>
                      <td></td>
                      <td>
                        <span v-if="director.Other2 ==''">Not Uploaded</span>
                        <span v-if="director.Other2 !=''">
                          <a target="_blank" :href="getImgUrl(director.Other2)">View</a>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="director.Other3 !=''">
                      <td>14.</td>
                      <td>{{director.Other3Name}}</td>
                      <td></td>
                      <td>
                        <span v-if="director.Other3 ==''">Not Uploaded</span>
                        <span v-if="director.Other3 !=''">
                          <a target="_blank" :href="getImgUrl(director.Other3)">View</a>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="director.Other4 !=''">
                      <td>15.</td>
                      <td>{{director.Other4Name}}</td>
                      <td></td>
                      <td>
                        <span v-if="director.Other4 ==''">Not Uploaded</span>
                        <span v-if="director.Other4 !=''">
                          <a target="_blank" :href="getImgUrl(director.Other4)">View</a>
                        </span>
                      </td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- documenets ends -->

      <div class="reg-form-box">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>

        <b-container class="bv-example-row">
          <b-row>
            <b-col cols="10" offset="1">
              <h5 class="reg-form-title text-primary">Approval History</h5>
              <b-table
                show-empty
                selectable
                select-mode="multi"
                head-variant="dark"
                empty-text="No Applications available."
                stacked="md"
                bordered
                striped
                :items="approvalHistoryRows"
                :fields="approvalFields"
                variant="dark"
                style="font-size:12px"
              ></b-table>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="personalDetails.ApprovalDoc!=''">
            <b-col cols="8" offset="1">
              <p>
                <b>DBSC Approval Status</b>
                : {{personalDetails.ApprovalStatus}}
                <a
                  class="ml-2"
                  target="_blank"
                  :href="getImgUrl2(personalDetails.ApprovalDoc)"
                >View Approval Report</a>
              </p>
              <p>
                <b>Meeting Date</b>
                : {{personalDetails.MeetingDate | formatDate}}
              </p>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- Printme id ends here -->

    <div class="reg-form-box">
      <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
      <b-alert
        :show="showDismissibleAlert"
        dismissible
        @dismissed="showDismissibleAlert=false"
        :variant="variant"
      >{{alertText}}</b-alert>
      <!-- <b-form @submit="onSubmit" class="hide-print" v-if="(
        ApplicationStatus==15 && RoleID==2) || (ApplicationStatus==1 && RoleID==2) || (ApplicationStatus==5 && RoleID==2) ||
        (ApplicationStatus==3 && RoleID==2) || (ApplicationStatus==13 && RoleID==3) || (ApplicationStatus==17 && RoleID==3) ||
        (ApplicationStatus==19 && RoleID==3) ||
      (ApplicationStatus==4 && RoleID==5) || (ApplicationStatus==16 && RoleID==4) || (ApplicationStatus==7 && RoleID==5)">-->
      <b-form @submit="onSubmit" class="hide-print" v-if="showApproval">
        <div class="form-row">
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-4">
            <!--<label for="ipDistrict" size="sm">District</label> -->
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="4"
              label-cols-lg="4"
              label="Approve Application"
              label-for="ipDistrict"
              label-size="sm"
            >
              <b-select
                id="ipDistrict"
                :options="ApprovalStatus"
                value-field="StatusID"
                text-field="Status"
                required
                size="sm"
                @change.native="checkReject"
                v-model="form.ApplicationStatus"
                class="form-control"
              ></b-select>
            </b-form-group>
          </div>
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-4">
            <b-form-group
              id="fieldset-horizontal2"
              label-cols-sm="4"
              label-cols-lg="4"
              label="Reject Reason"
              label-for="ipReason"
              label-size="sm"
            >
              <!-- <b-select id="ipReason"
                :options="RejectReasons"
                value-field="RejectedID"
                text-field="RejectedTypeName"
                required
                size="sm"
                :disabled="form.ApplicationStatus!=3 && form.ApplicationStatus !=5 && form.ApplicationStatus !=7 && form.ApplicationStatus !=17 && form.ApplicationStatus !=18"
                v-model="form.RejectReason"
              class="form-control">-->
              <b-select
                id="ipReason"
                :options="RejectReasons"
                value-field="RejectedID"
                text-field="RejectedTypeName"
                required
                size="sm"
                :disabled="!isReject"
                v-model="form.RejectReason"
                class="form-control"
              ></b-select>
            </b-form-group>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-9" style="text-align:left">
            <!--<label for="ipDistrict" size="sm">District</label> -->
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="4"
              label-cols-md="1"
              label="Remarks"
              label-for="ipRemarks"
              label-size="sm"
            >
              <!-- <b-form-textarea id="ipRemarks"
                v-model="form.Remarks"
                :required="form.ApplicationStatus==3 && form.ApplicationStatus ==5 && form.ApplicationStatus ==7 && form.ApplicationStatus ==17"
                size="sm"
                rows=2, max-rows="4"
              placeholder="Remarks">-->
              <b-form-textarea
                id="ipRemarks"
                v-model="form.Remarks"
                :required="isReject"
                size="sm"
                rows="2,"
                max-rows="4"
                placeholder="Remarks"
              ></b-form-textarea>
            </b-form-group>
          </div>
        </div>
        <b-col style="text-align:center" class="mb-3">
          <b-button class="hide-print" type="submit" variant="primary" v-if="showButton">Submit</b-button>
        </b-col>
      </b-form>
      <div class="text-center">
        <b-button class="hide-print" @click.prevent="goback" variant="secondary" size="small">BACK</b-button>
      </div>
    </div>
    <b-modal ref="loiModal" size="xl" hide-footer title="LOI">
      <LoanLOIPrint
        :ApplicationID="form.ApplicationID"
        :Loantype="2"
        :UserID="UserID"
        :PastLOI="PastLOI"
        :ApplicantCasteName="personalDetails.CasteName"
        :ApplicantCasteCode="personalDetails.CasteID"
      ></LoanLOIPrint>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import Spinner from "vue-simple-spinner";
import LoanLOIPrint from "@/components/RegistrationLoan/LoanLOIPrint";
import { detectTenant, filterCasteDropdown } from "@/tenantConfig";

export default {
  components: { Spinner, DatePicker, LoanLOIPrint },
  props: ["UserID", "ApplicationStatus"],
  data() {
    return {
      showButton: true,
      showApproval: false,
      isReject: false,
      required: false,
      Caste: [],
      CasteID: "",
      PastLOI: false,
      personalDetails: {},
      directorDetails: [],
      shareholderDetails: [],
      familyDetails: [],
      docObj: {},
      docTbl: [],
      form: {
        ApplicationStatus: 1,
        RejectReason: 0,
        Remarks: "",
        UserID: "",
        ApplicationID: ""
      },
      RoleID: 0,
      ApprovalStatus: [
        //{ StatusID: 1, Status: "Pending" },
        { StatusID: 2, Status: "Verified" },
        { StatusID: 3, Status: "Hold" },
        { StatusID: 19, Status: "Rejected" }
        //{ StatusID: 15, Status: "Scheduled" }
      ],
      approvalRemarks: [],
      approvalFields: [
        "ApplicationStatus",
        "RejectionReason",
        "Remarks",
        {
          key: "LogDate",
          label: "Approve/Reject Date",
          formatter: "convertDateFormat"
        },
        "ApproverName"
      ],
      RejectReasons: [],
      alertText: "",
      variant: "success",
      isLoading: false,
      showDismissibleAlert: false,
      editList: {
        eDOB: false,
        ePan: false,
        eAadhar: false,
        eRation: false,
        eCaste: false,
        eAccount: false,
        eAddress: false
      },
      DOB: null,
      updateForm: {
        UserID: null,
        LoanApplicationID: null,
        DOB: null,
        Age: null,
        Pan: null,
        Aadhar: null,
        BankAccount: null,
        RationCard: null,
        CasteID: null,
        CreatedUser: null
      }
    };
  },
  computed: {
    approvalHistoryRows() {
      return this.uniqueApprovalRemarks(this.approvalRemarks);
    },
    validateAadhar() {
      if (this.personalDetails.AdharNo == null) {
        return false;
      }

      if (this.personalDetails.AdharNo.length == 0) {
        return false;
      } else if (this.personalDetails.AdharNo != null) {
        var adharformat = /^\d{12}$/;
        if (this.personalDetails.AdharNo.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validatePan() {
      if (this.personalDetails.PanCardNo == null) {
        return false;
      }

      if (this.personalDetails.PanCardNo.length == 0) {
        return false;
      } else if (this.personalDetails.PanCardNo != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.personalDetails.PanCardNo.match(panformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateAge() {
      // console.log('1');
      //let age = this.calculateAge(this.form.DOB);

      let age = this.calculateAge(this.DOB);
      this.PersonalDetails.Age = age;
      if (age < 18 || age >= 50) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    isLoiExtensionStatus(statusId) {
      return [21, 23, 24, 25, 26, 27, 28, 29, 32, 33, 34].indexOf(Number(statusId)) !== -1;
    },
    normalizeApprovalRemarkRows(rows) {
      return (Array.isArray(rows) ? rows : []).map((row) => {
        return Object.assign({}, row, {
          Remarks: row.Remarks || row.RejectRemarks || ""
        });
      });
    },
    hasUsableApprovalDate(value) {
      var text = String(value || "").trim();
      return text !== "" && text.indexOf("0001-01-01") === -1;
    },
    getCurrentApprovalRemarkRow(rows) {
      var app = this.GroupInformation;
      if (!app) {
        return null;
      }

      var statusText = String(app.LoanApplicationStatus || app.ApplicationStatusText || "").trim();
      if (!statusText) {
        return null;
      }

      var normalizedStatusText = statusText.toLowerCase();
      var alreadyShown = (Array.isArray(rows) ? rows : []).some((row) => {
        return String(row.ApplicationStatus || "").trim().toLowerCase() === normalizedStatusText;
      });
      if (alreadyShown) {
        return null;
      }

      return {
        ApplicationID: this.form.ApplicationID,
        ApplicationStatus: statusText,
        RejectionReason: "",
        Remarks: "",
        LogDate: this.hasUsableApprovalDate(app.Level1ApprovalDate) ? app.Level1ApprovalDate : "",
        ApproverName: "",
        ApplicationNo: app.LoanApplicationNo || null
      };
    },
    shouldSuppressApprovalRemark() {
      return false;
    },
    parseApprovalHistoryDate(value) {
      var text = String(value || "").trim();
      if (!text || text.indexOf("0001-01-01") !== -1) {
        return null;
      }

      var parsed = new Date(text);
      if (!isNaN(parsed.getTime())) {
        return parsed;
      }

      var match = text.match(/^(\d{1,2})[-\s]([A-Za-z]{3,})[-\s](\d{4})$/);
      if (!match) {
        return null;
      }

      var months = {
        jan: 0, january: 0,
        feb: 1, february: 1,
        mar: 2, march: 2,
        apr: 3, april: 3,
        may: 4,
        jun: 5, june: 5,
        jul: 6, july: 6,
        aug: 7, august: 7,
        sep: 8, sept: 8, september: 8,
        oct: 9, october: 9,
        nov: 10, november: 10,
        dec: 11, december: 11
      };
      var month = months[match[2].toLowerCase()];
      if (month === undefined) {
        return null;
      }

      return new Date(Number(match[3]), month, Number(match[1]));
    },
    getAgmRecommendationDisplayDate(rows, dgmRow) {
      var list = Array.isArray(rows) ? rows : [];
      var dgmDate = this.parseApprovalHistoryDate(dgmRow && dgmRow.LogDate);
      var candidates = list.filter((row) => {
        var statusText = String(row.ApplicationStatus || "").trim().toLowerCase();
        if (statusText === "recommended by dgm project" || statusText === "recommended by agm project") {
          return false;
        }
        return !!this.parseApprovalHistoryDate(row.LogDate);
      });

      if (dgmDate) {
        candidates = candidates.filter((row) => {
          var rowDate = this.parseApprovalHistoryDate(row.LogDate);
          return rowDate && rowDate.getTime() <= dgmDate.getTime();
        });
      }

      candidates.sort((left, right) => {
        return this.parseApprovalHistoryDate(right.LogDate).getTime() - this.parseApprovalHistoryDate(left.LogDate).getTime();
      });

      return candidates.length > 0 ? candidates[0].LogDate : "";
    },
    fillBlankAgmRecommendationRemarks(rows) {
      return Array.isArray(rows) ? rows : [];
    },
    getMissingAgmApprovalRemarkRow(rows) {
      var list = Array.isArray(rows) ? rows : [];
      var hasAgmRow = list.some((row) => {
        return String(row.ApplicationStatus || "").trim().toLowerCase() === "recommended by agm project";
      });
      if (hasAgmRow) {
        return null;
      }

      var dgmRow = list.find((row) => {
        return String(row.ApplicationStatus || "").trim().toLowerCase() === "recommended by dgm project";
      });
      if (!dgmRow) {
        return null;
      }

      var agmDate = this.getAgmRecommendationDisplayDate(list, dgmRow);

      return {
        ApplicationID: dgmRow.ApplicationID || this.form.ApplicationID,
        ApplicationStatus: "Recommended by AGM Project",
        RejectionReason: "",
        Remarks: "",
        LogDate: agmDate,
        ApproverName: "HO Mumbai",
        ApplicationNo: dgmRow.ApplicationNo || null
      };
    },
    uniqueApprovalRemarks(rows) {
      const seen = {};
      const normalizedRows = this.fillBlankAgmRecommendationRemarks(this.normalizeApprovalRemarkRows(rows)).filter((row, index, list) => {
        return !this.shouldSuppressApprovalRemark(row, index, list);
      });
      const currentRow = this.getCurrentApprovalRemarkRow(normalizedRows);
      const missingAgmRow = this.getMissingAgmApprovalRemarkRow(normalizedRows);
      var rowsWithMissingAgm = normalizedRows;
      if (missingAgmRow) {
        var missingAgmInserted = false;
        rowsWithMissingAgm = [];
        normalizedRows.forEach((row) => {
          rowsWithMissingAgm.push(row);
          if (!missingAgmInserted && String(row.ApplicationStatus || "").trim().toLowerCase() === "recommended by dgm project") {
            rowsWithMissingAgm.push(missingAgmRow);
            missingAgmInserted = true;
          }
        });
        if (!missingAgmInserted) {
          rowsWithMissingAgm.push(missingAgmRow);
        }
      }
      const displayRows = (currentRow ? [currentRow] : []).concat(rowsWithMissingAgm);
      return displayRows.filter((row) => {
        const key = [
          row.ApplicationStatus || row.ClaimStatus || row.Status || "",
          row.RejectionReason || row.RejectedReason || "",
          row.ApprovedAmount || row.ApprovedAmt || "",
          row.RejectedAmount || row.RejectedAmt || "",
          row.RejectRemarks || row.Remarks || "",
          row.LogDate || row.ApproveRejectDate || row.ApprovalDate || "",
          row.ApproverName || row.ApprovedBy || ""
        ].map((value) => String(value || "").trim().toLowerCase()).join("|");
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    },
    getApprovalStatusLabel(statusId) {
      var selectedStatus = (this.ApprovalStatus || []).find((item) => {
        return Number(item.StatusID) === Number(statusId);
      });
      return selectedStatus && selectedStatus.Status ? selectedStatus.Status : "";
    },
    addSubmittedApprovalRemark(statusId, remarks) {
      var statusText = this.getApprovalStatusLabel(statusId);
      if (!statusText) {
        return;
      }

      var userinfo = this.$store && this.$store.getters ? this.$store.getters.loggedUser : null;
      var submittedRow = {
        ApplicationID: this.form.ApplicationID,
        ApplicationStatus: statusText,
        RejectionReason: "",
        Remarks: remarks || "",
        LogDate: new Date(),
        ApproverName: userinfo && userinfo.UserName ? userinfo.UserName : "",
        ApplicationNo: null
      };

      this.approvalRemarks = [submittedRow].concat(Array.isArray(this.approvalRemarks) ? this.approvalRemarks : []);
    },
    checkReject(evt) {
      let id = parseInt(evt.target.value);
      let appStatus = _.filter(this.ApprovalStatus, { StatusID: id });
      if (appStatus) {
        if (appStatus.length > 0) {
          this.isReject = appStatus[0].ISReject;
          if (!this.isReject) {
            this.form.RejectReason = 0;
          }
        }
      }
    },
    goback() {
      this.$router.push({
        name: "Applications"
      });
    },
    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let incrementDate = new Date(birthDate);
      // console.log(incrementDate);
      let today = new Date();
      let n = 0;
      while (incrementDate < today) {
        n++;
        incrementDate.setYear(incrementDate.getFullYear() + 1);
      }

      return n - 1;
    },
    convertDateFormat(inDate) {
      var text = String(inDate || "").trim();
      if (!text || text.indexOf("0001-01-01") !== -1) {
        return "";
      }
      return Formatter.convertDateFormat(inDate);
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.form.ApplicationStatus == this.ApplicationStatus) {
        return;
      }

      var submittedStatus = this.form.ApplicationStatus;
      var submittedRemarks = this.form.Remarks;

      let promise = apis.UpdateApplicationStatus(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            //Check the profile completion status
            this.alertText = response.body;
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.isLoading = false;
            this.showButton = false;
            this.addSubmittedApprovalRemark(submittedStatus, submittedRemarks);
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    print() {
      window.print();
      //this.$htmlToPaper("printme");
    },
    edit() {
      this.$router.push("/LoginProfile");
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          this.UserID +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/msobcfdc_bsc/" + pic
        );
      }
    },
    EditField(fld) {
      if (this.editList[fld]) {
        switch (fld) {
          case "ePan":
            if (!this.validatePan) {
              this.alertText = "Please verify the PAN";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.Pan = this.personalDetails.PanCardNo;
            break;
          case "eAadhar":
            if (!this.validateAadhar) {
              this.alertText = "Please verify the Aadhar number";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.Aadhar = this.personalDetails.AdharNo;
            break;
          case "eRation":
            this.updateForm.RationCard = this.personalDetails.RationCardNo;
            break;
          case "eDOB":
            if (!this.validateAge) {
              this.alertText = "Age Criteria not fulfilled";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.DOB = Formatter.convertDateFormatYMD(this.DOB);
            this.updateForm.Age = this.age;
            break;
          case "eCaste":
            let casteName = _.filter(this.Caste, { CasteID: this.CasteID });
            this.personalDetails.CasteName = casteName[0].CasteName;
            this.updateForm.CasteID = this.CasteID;
            break;
          case "eAccount":
            this.updateForm.BankAccount = this.personalDetails.UserBankAccount.BankAccountNo;
            break;
        }
        this.updateForm.UserID = this.UserID;
        this.updateForm.LoanApplicationID = this.form.ApplicationID;
        this.updateForm.CreatedUser = this.$store.getters.loggedUser.UserId;

        let promiseA = apis.saveDMChanges(this.updateForm);

        promiseA
          .then(response => {
            if (response.status == 200) {
              this.alertText = "Data Saved Successfully";
              this.variant = "success";
              this.showDismissibleAlert = true;
            } else {
              this.alertText = "Error while Updating Data, " + response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
          })
          .catch(err => {
            this.alertText = "Error while Updating Data, " + err.message;
            this.showDismissibleAlert = true;
            this.variant = "danger";
          });
      } else {
        switch (fld) {
          case "eCaste":
            let casteid = _.filter(this.Caste, {
              CasteName: this.personalDetails.CasteName
            });
            this.CasteID = casteid[0].CasteID;
            break;
        }
      }
      this.editList[fld] = !this.editList[fld];
    },
    CloseField(fld) {
      this.editList[fld] = !this.editList[fld];
    },
    getCaste() {
      let promiseA = apis.getCaste();

      promiseA
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            this.Caste = filterCasteDropdown(response.body, detectTenant());
          } else {
            this.alertText = "Unable to get caste List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = "Unable to get caste List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    printLoi() {
      this.PastLOI = false;
      this.$refs["loiModal"].show();
      // this.$router.push({
      //   name: "LoanLOIPrint",
      //   params: { ApplicationID: this.form.ApplicationID, Loantype: 1, UserID: this.UserID }
      // });
    },

    printLoiOld() {
      this.PastLOI = true;
      this.$refs["loiModal"].show();
      // this.$router.push({
      //   name: "LoanLOIPrint",
      //   params: { ApplicationID: this.form.ApplicationID, Loantype: 1, UserID: this.UserID }
      // });
    },
    extendLoi() {
      var appform = {
        ApplicationIDs: [this.form.ApplicationID],
        CreatedUser: this.$store.getters.loggedUser.UserId
      };

      var t = this;
      this.$dialog
        .prompt(
          {
            title: "Confirm LOI Extension",
            body:
              "A New LOI will be issued for the selected Application, Do you want to Continue?"
          },
          {
            promptHelp: 'Provide Remarks and click "[+:okText]"',
            okText: "Extend LOI",
            cancelText: "Cancel",
            loader: false
          }
        )
        .then(function(dialog) {
          if (dialog.data) {
            appform.remarks = dialog.data;
          } else {
            t.$dialog.alert("Please enter Remarks");
            return;
          }
          return apis.ExtendLoi(appform);
        })
        .then(response => {
          if (response != undefined) {
            if (response.status == 200) {
              this.$dialog.alert(
                "New LOI Issued for the Selected Applications"
              );
              t.getApplicationsSub();
            } else {
              this.$dialog.alert("Unable to save changes");
            }
          }
        })
        .catch(err => {
          if (err != false) {
            this.$dialog.alert("Error while saving data");
          }
        });

      // let promiseA = apis.ExtendLoi(appform);

      // promiseA
      //   .then(response => {
      //     if (response.status == 200) {
      //       alert("New LOI Issued");
      //       this.alertText = "New LOI Issued";
      //       this.variant = "Success";
      //       this.showDismissibleAlert = true;
      //     }
      //   })
      //   .catch(err => {
      //     this.alertText = "Unable to Save Changes, " + err.message;
      //     this.showDismissibleAlert = true;
      //     this.variant = "danger";
      //   });
    }
  },

  mounted() {
    this.editList = {
      eDOB: false,
      ePan: false,
      eAadhar: false,
      eRation: false,
      eCaste: false,
      eAccount: false,
      eAddress: false
    };
    this.getCaste();
    var userinfo = this.$store.getters.loggedUser;
    this.RoleID = userinfo.RoleID;
    this.form.ApplicationStatus = this.ApplicationStatus;
    this.showApproval = false;
    let promise = apis.ReadApplicationStatusByRoleStatus({
      Role: userinfo.RoleID,
      Status: this.ApplicationStatus
    });

    promise
      .then(response => {
        if (response.status == 200) {
          this.ApprovalStatus = JSON.parse(response.body);
          if (this.ApprovalStatus.length > 0) {
            this.showApproval = true;
          }
        } else {
          this.ApprovalStatus = [];
        }
      })
      .catch(err => {
        this.ApprovalStatus = [];
        this.alertText = "Error in Loading Application Staus Master";
        this.variant = "danger";
        this.showDismissibleAlert = true;
      });

    this.form.UserID = userinfo.UserId;
    let promiseU = apis.ReadGroupProfile(this.UserID); //Personal Details

    promiseU
      .then(response => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body.Table[0];
          this.familyDetails = response.body.Table1;
          this.directorDetails = response.body.Table2;
          this.shareholderDetails = response.body.Table3;
          this.form.ApplicationID = this.personalDetails.LoanApplicationID;
          if (
            this.personalDetails.ApprovalDoc != "" &&
            this.ApplicationStatus == 3
          ) {
            this.ApprovalStatus.unshift({
              StatusID: 19,
              Status: "Re-Verified by DM"
            });
          }
          let promiseA = apis.ReadApprovalRemarks(this.form.ApplicationID);
          promiseA.then(response => {
            if (response.status == 200) {
              this.approvalRemarks = response.body;
            }
          });

          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    let promiseR = apis.ReadRejectTypes();

    promiseR
      .then(response => {
        if (response.status == 200) {
          this.RejectReasons = response.body;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ViewGroupDetailsProfile.vue